export const SEO_HOME_EN = {
  title: "Lucentia Social | Instagram, websites and bookings for appointment businesses",
  description:
    "Instagram management, websites and online booking for appointment-based businesses in Spain. Plans from €249/month and a free strategic audit with Jenifer Roelstraete.",
  path: "/",
  keywords:
    "more bookings, booking system, business automation, digital strategy, Instagram bookings, web design, Jenifer Roelstraete, Lucentia Social, lucentiasocial.com, Spain, Argentina",
  ogImage: "/og-image.jpg",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogImageAlt: "Lucentia Social — digital strategy and automation for more bookings",
  breadcrumbHome: "Home",
} as const;

export const SEO_METHOD_EN = {
  title: "The Lucentia System® — More bookings without isolated tools | Lucentia Social",
  description:
    "Discover the Lucentia System®: Instagram, web, bookings and automation working together to attract clients and grow your business.",
  path: "/metodo",
  keywords:
    "Lucentia System, booking system, digital strategy, business automation, more bookings, Lucentia Social",
  ogImage: "/og-image.jpg",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogImageAlt: "The Lucentia System® — a system to get more bookings",
  breadcrumbMethod: "Lucentia System",
} as const;

export const SEO_INSTAGRAM_ADVISORY_EN = {
  title:
    "Strategic Instagram Advisory — Personalised strategy | Lucentia Social",
  description:
    "Learn how to manage your business Instagram with a 100% personalised video advisory, Lucentia Implementation Kit and 7 days of WhatsApp support.",
  path: "/asesoria-instagram",
  keywords:
    "Instagram advisory, Instagram strategy for businesses, Lucentia implementation kit, DIY community management, Lucentia Social",
  ogImage: "/og-image.jpg",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogImageAlt: "Strategic Instagram Advisory — Lucentia Social",
  breadcrumb: "Strategic Instagram Advisory",
} as const;

export const SEO_INSTAGRAM_MANAGEMENT_EN = {
  title:
    "Strategic Instagram Management — More bookings | Lucentia Social",
  description:
    "Full Instagram management for booking-based businesses: strategy, content, design, community and continuous optimisation to fill your calendar.",
  path: "/gestion-instagram",
  keywords:
    "strategic Instagram management, community management bookings, Instagram for businesses, Instagram content, Lucentia Social",
  ogImage: "/og-image.jpg",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogImageAlt: "Strategic Instagram Management — Lucentia Social",
  breadcrumb: "Strategic Instagram Management",
} as const;

export const SEO_WEB_SERVICE_EN = {
  title: "Strategic Website — Turn visits into bookings | Lucentia Social",
  description:
    "Custom web design with online bookings, SEO, AEO, GEO, WhatsApp and AI. Websites built for booking-based businesses that want to convert more.",
  path: "/pagina-web",
  keywords:
    "strategic website, booking website design, SEO AEO GEO, online bookings, Lucentia Social",
  ogImage: "/og-image.jpg",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogImageAlt: "Strategic Website — Lucentia Social",
  breadcrumbWeb: "Strategic Website",
} as const;

export const SEO_RESOURCES_EN = {
  title: "Free resources to grow your business | Lucentia Social",
  description:
    "Free guides from Lucentia Social: Instagram Profile Optimisation and the Lucentia System Map for connecting Instagram, your website and bookings.",
  path: "/recursos",
  keywords:
    "free resources, free Instagram guide, optimise Instagram profile, bio that sells, online bookings, Lucentia Social, lucentiasocial.com, Spain, Argentina",
  ogImage: "/og-image.jpg",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  breadcrumbResources: "Resources",
  itemListName: "Free Lucentia Social resources",
} as const;

export const SEO_PRICING_EN = {
  title: "Instagram management and community manager pricing | Lucentia Social",
  description:
    "Instagram management plans from €249/month, a €130 Welcome pack and rates for reels, posts and carousels. Clear prices and what each plan includes.",
  path: "/precios",
  keywords:
    "community manager price, Instagram management pricing, social media packages, reel rates, Lucentia Social",
  ogImage: "/og-image.jpg",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogImageAlt: "Lucentia Social pricing and plans",
  breadcrumb: "Pricing",
} as const;

export const SEO_NOT_FOUND_EN = {
  title: "Page not found | Lucentia Social",
  description: "The page you're looking for doesn't exist or has moved.",
} as const;

export const SEO_LEGAL_EN = {
  keywords:
    "legal notice, privacy policy, cookies, GDPR, LOPDGDD, Lucentia Social, lucentiasocial.com",
} as const;

export const SEO_PERSON_JOB_TITLE_EN = "Digital strategist & booking specialist";
export const SEO_SERVICE_NAME_EN = "Lucentia Social — Digital strategy and booking systems";
export const SEO_SERVICE_TYPES_EN = [
  "Strategic Instagram Management",
  "Strategic Instagram Advisory",
  "Strategic Website",
  "Booking systems",
  "Business automation",
] as const;
export const SEO_AREA_SERVED_EN = [
  { "@type": "Country", name: "Spain" },
  { "@type": "Country", name: "Argentina" },
] as const;
